import VehicleParked from "../assets/parking/image1/vehicleParked.JPG";
import ExitGateCloseImg from "../assets/parking/image1/exitGateCloseImg.png";
import VehicleEntered from "../assets/parking/image1/vehicle-entered2.PNG";
import VehicleEntryExit from "../assets/parking/image1/vehicleExit.jpeg";
import AccidentDetected from "../assets/parking/image1/accidentDetected.JPG";
import OccupancyFifty from "../assets/parking/image1/parkingFullNew.JPG";
import BusEntered from "../assets/parking/image1/busEntered.PNG";
import BusExit from "../assets/parking/image1/busExit.PNG";
import WrongParking from "../assets/parking/image1/wrong-parking-4.PNG";
import ReverseParking from "../assets/parking/image1/reverseParking1.PNG";
import CloseParking from "../assets/parking/image1/closeParking.PNG";
import NoParking from "../assets/parking/image1/noParking.PNG";
import Maintenance from "../assets/parking/image1/maintenanceInProgressImg.png";
import ParkingAvailable from "../assets/parking/image1/parkingAvailable.png";
import AccessDenied from "../assets/security/images1/accessDenied.PNG";
import UnauthorizedAccess from "../assets/security/images1/unauthorizedAccess.PNG";
import CrowedForming from "../assets/security/images1/crowdForming.PNG";
import Tailgating from "../assets/security/images1/tailgating.PNG";
import CameraNotFunctional from "../assets/security/images1/cameraNotFunctional1.png";
import LicensePlateNumberNotFound from "../assets/parking/image1/withoutNumberPlate.png";
import MaintenanceInProgress from "../assets/security/images1/maintenance-In-progress.PNG";
import ParkingSlotUnderMaintenance from "../assets/security/images1/parking-slot-underMaintenance.PNG";

import MaintanenceCompleted from "../assets/parking/image1/maintenanceCompletedImg-2.png";
import ShareTurningImg from "../assets/parking/image1/shareTurningImg.png";

import EscalatorMaintenance from "../assets/security/images1/escalatorMaintanence.PNG";
import FireAlert from "../assets/security/images1/fire-alert.PNG";
import ReEntryGateClosed from "../assets/security/images1/re-entry-gate-closed.PNG";
import SmockDeteded from "../assets/operations/images/smockDeteded.PNG";
import StockLevel from "../assets/operations/images/StockLevel.JPG";
import StockLevelThirty from "../assets/operations/images/StockLevel-thirty-img.png";
import NotOperational from "../assets/operations/images/notOperational.JPG";
import HighTempture from "../assets/operations/images/highTempture.JPG";
import ClosedForCleaningImg from "../assets/operations/images/closedForCleaningImg.png";
import RestarentOpen from "../assets/operations/images/RestarentOpen.JPG";
import RestaurantUnderMaintenance from "../assets/operations/images/restaurantMaintanceImg.png";
import vendingMachineRestockingDone from "../assets/operations/images/vending-machine-Restocking-done-img.png";
import RestaurantOperational from "../assets/operations/images/Restaurant-operational.jpg";
import RestaurantGettingClean from "../assets/operations/images/Restaurant-getting-clean.jpg";
import CleaningInprogressImg from "../assets/operations/images/cleaningInprogressImg.png";
import GateOpenImg from "../assets/operations/images/gateOpenImg.png";
import GateCloseImg from "../assets/operations/images/gateCloseImg.png";

import VehicleParkedVideo from "../assets/parking/video1/vehicleParked.mp4";
import ExitGateCloseVideo from "../assets/parking/video1/exitGateClose.mp4";
import vehicleEnteredVideo from "../assets/parking/video1/vehicleEntered.mp4";
import VehicleEntryExitVideo from "../assets/parking/video1/entry-exit-cars.mp4";
import AccidentDetectedVideo from "../assets/parking/video1/accidentDetected.mp4";
import OccupancyFiftyVideo from "../assets/parking/video1/parkingFull.webm";
import busEnteredVideo from "../assets/parking/video1/busEntered.webm";
import busExitVideo from "../assets/parking/video1/busExit.webm";
import WrongParkingVideo from "../assets/parking/video1/wrongParking.webm";
import ReverseParkingVideo from "../assets/parking/video1/reverseParking.webm";
import CloseParkingVideo from "../assets/parking/video1/closeParking.mp4";
import NoParkingVideo from "../assets/parking/video1/noParking.webm";
import MaintenanceVideo from "../assets/parking/video1/maintenanceInProgress.webm";
import ParkingAvailableVideo from "../assets/parking/video1/parkingAvailable.webm";
import AccessDeniedVideo from "../assets/security/video1/accessDenied.mp4";
import UnauthorizedAccessVideo from "../assets/security/video1/unauthorizedAccess.mp4";
import CrowedFormingVideo from "../assets/security/video1/crowedForming-1.webm";
import TailgatingVideo from "../assets/security/video1/tailgating.mp4";
import CameraNotFunctionalVideo from "../assets/security/video1/cameraNotFunctional.mp4";
import LicensePlateNumberNotFoundVideo from "../assets/parking/video1/withoutNumberPlateVideo.webm";
import MaintenanceInProgressVideo from "../assets/security/video1/maintenance-In-progress.webm";
import ParkingSlotUnderMaintenanceVideo from "../assets/security/video1/parking-slot-underMaintenance.webm";

import MaintanenceCompletedVideo from "../assets/parking/video1/maintenanceCompleted-2.mp4";
import ShareTurningVideo from "../assets/parking/video1/shareTurning.mp4";

import EscalatorMaintenanceVideo from "../assets/security/video1/escalator-maintenance2.webm";
import FireAlertVideo from "../assets/security/video1/fire-alert.webm";
import ReEntryGateClosedVideo from "../assets/security/video1/re-entry-gate-closed.mp4";
import SmokeDetectedVideo from "../assets/operations/videos/Smoke-detected2.webm";
import StockLevelThirtyVideo from "../assets/operations/videos/Stock-level-30.webm";
import NotOperationalVideo from "../assets/operations/videos/Not-operational.webm";
import VendingMachineStockThirty from "../assets/operations/videos/StockLevel-thirty.mp4";
import HighTemperatureVideo from "../assets/operations/videos/High-temperature.webm";
import ClosedForCleaningVideo from "../assets/operations/videos/closedForCleaning.mp4";
import RestaurantOpenVideo from "../assets/operations/videos/restaurant-open.webm";
import RestaurantUnderMaintenanceVideo from "../assets/operations/videos/restaurantMaintance.mp4";
import VendingMachineRestockingDoneVideo from "../assets/operations/videos/Vending-machine-Restocking-done.mp4";
import RestaurantOperationalVideo from "../assets/operations/videos/Restaurant-operational.mp4";
import RestaurantCleaningVideo from "../assets/operations/videos/Restaurant-cleaning.mp4";
import CleaningInprogressVideo from "../assets/operations/videos/cleaningInprogress.mp4";
import GateOpenVideo from "../assets/operations/videos/gateOpen.mp4";
import GateCloseVideo from "../assets/operations/videos/gateCloseVideo.mp4";

import GoodSignalStrengthVideo from "../assets/outdoor/video/GoodSignalStrength.mp4";
import HazardousAQIVideo from "../assets/outdoor/video/HazardousAQI.mp4";
import HighElectricityConsumptionVideo from "../assets/outdoor/video/HighElectricityConsumption.mp4";
import ModerateAQIVideo from "../assets/outdoor/video/ModerateAQI.mp4";
import WeakSignalStrengthVideo from "../assets/outdoor/video/WeakSignalStrength.mp4";
import WifiNotOperationalVideo from "../assets/outdoor/video/WifiNotOperational.mp4";

import GoodSignalStrengthImage from "../assets/outdoor/image/GoodSignalStrength.png";
import HazardousAQIImage from "../assets/outdoor/image/HazardousAQI.png";
import HighElectricityConsumptionImage from "../assets/outdoor/image/HighElectricityConsumption.png";
import ModerateAQIImage from "../assets/outdoor/image/ModerateAQI.png";
import WeakSignalStrengthImage from "../assets/outdoor/image/WeakSignalStrength.png";
import WifiNotOperationalImage from "../assets/outdoor/image/WifiNotOperational.png";

import LowInventoryLevelImage from "../assets/food/image/LowInventoryLevel.png";
import OrderDelayedImage from "../assets/food/image/OrderDelayed.png";
import PendingOrderImage from "../assets/food/image/PendingOrder.png";
import FoodRestaurantOpenImage from "../assets/food/image/RestaurantOpen.png";

import LowInventoryLevelVideo from "../assets/food/video/LowInventoryLevel.mp4";
import OrderDelayedVideo from "../assets/food/video/OrderDelayed.mp4";
import PendingOrderVideo from "../assets/food/video/PendingOrder.mp4";
import FoodRestaurantOpenVideo from "../assets/food/video/RestaurantOpen.mp4";

import DefaultVideo from "../assets/video/parkingVideo.webm";

const List = [
  {
    category: "parking",
    title: "sharp turns",
    image: ShareTurningImg,
    video: ShareTurningVideo,
  },
  {
    category: "operations",
    title: "entrance gate closed",
    image: GateCloseImg,
    video: GateCloseVideo,
  },
  {
    category: "operations",
    title: "entrance gate opened",
    image: GateOpenImg,
    video: GateOpenVideo,
  },
  {
    category: "operations",
    title: "restroom cleaning inprogress",
    image: CleaningInprogressImg,
    video: CleaningInprogressVideo,
  },
  {
    category: "operations",
    title: "restaurant is getting clean",
    image: RestaurantGettingClean,
    video: RestaurantCleaningVideo,
  },
  {
    category: "operations",
    title: "restaurant is operational now",
    image: RestaurantOperational,
    video: RestaurantOperationalVideo,
  },
  {
    category: "operations",
    title: "restocking done",
    image: vendingMachineRestockingDone,
    video: VendingMachineRestockingDoneVideo,
  },
  {
    category: "operations",
    title: "restaurant is under maintenance",
    image: RestaurantUnderMaintenance,
    video: RestaurantUnderMaintenanceVideo,
  },
  {
    category: "operations",
    title: "restaurants open",
    image: RestarentOpen,
    video: RestaurantOpenVideo,
  },
  {
    category: "operations",
    title: "closed for cleaning",
    image: ClosedForCleaningImg,
    video: ClosedForCleaningVideo,
  },
  {
    category: "operations",
    title: "high temperature",
    image: HighTempture,
    video: HighTemperatureVideo,
  },
  {
    category: "operations",
    title: "stock level 30 %",
    image: StockLevelThirty,
    video: VendingMachineStockThirty,
  },
  {
    category: "operations",
    title: "not operational",
    image: NotOperational,
    video: NotOperationalVideo,
  },
  {
    category: "operations",
    title: "exit gate closed",
    image: ExitGateCloseImg,
    video: ExitGateCloseVideo,
  },
  {
    category: "parking",
    title: "vehicle parked",
    image: VehicleParked,
    video: VehicleParkedVideo,
  },
  {
    category: "parking",
    title: "vehicle entered",
    image: VehicleEntered,
    video: vehicleEnteredVideo,
  },
  {
    category: "parking",
    title: "vehicle exited",
    image: VehicleEntryExit,
    video: VehicleEntryExitVideo,
  },
  {
    category: "parking",
    title: "accident detected",
    image: AccidentDetected,
    video: AccidentDetectedVideo,
  },
  {
    category: "parking",
    title: "occupancy 50%",
    image: OccupancyFifty,
    video: OccupancyFiftyVideo,
  },
  {
    category: "parking",
    title: "bus entered",
    image: BusEntered,
    video: busEnteredVideo,
  },
  {
    category: "parking",
    title: "bus exited",
    image: BusExit,
    video: busExitVideo,
  },
  {
    category: "parking",
    title: "wrong parking",
    image: WrongParking,
    video: WrongParkingVideo,
  },
  {
    category: "parking",
    title: "double parking",
    image: VehicleParked,
    video: VehicleParkedVideo,
  },
  {
    category: "parking",
    title: "reverse parking",
    image: ReverseParking,
    video: ReverseParkingVideo,
  },
  {
    category: "parking",
    title: "close parking",
    image: CloseParking,
    video: CloseParkingVideo,
  },
  {
    category: "parking",
    title: "no parking",
    image: NoParking,
    video: NoParkingVideo,
  },
  {
    category: "parking",
    title: "parking slot is full",
    image: OccupancyFifty,
    video: OccupancyFiftyVideo,
  },
  {
    category: "parking",
    title: "parking slot is in maintenance",
    image: Maintenance,
    video: MaintenanceVideo,
  },
  {
    category: "security",
    title: "access denied",
    image: AccessDenied,
    video: AccessDeniedVideo,
  },
  {
    category: "security",
    title: "unauthorized access",
    image: UnauthorizedAccess,
    video: UnauthorizedAccessVideo,
  },
  {
    category: "security",
    title: "crowd forming",
    image: CrowedForming,
    video: CrowedFormingVideo,
  },
  {
    category: "operations",
    title: "crowd forming",
    image: CrowedForming,
    video: CrowedFormingVideo,
  },
  {
    category: "security",
    title: "tailgating",
    image: Tailgating,
    video: TailgatingVideo,
  },
  {
    category: "security",
    title: "license plate number not found",
    image: LicensePlateNumberNotFound,
    video: LicensePlateNumberNotFoundVideo,
  },
  {
    category: "security",
    title: "maintenance inprogress",
    image: MaintenanceInProgress,
    video: MaintenanceInProgressVideo,
  },

  {
    category: "security",
    title: "maintenance completed",
    image: MaintanenceCompleted,
    video: MaintanenceCompletedVideo,
  },
  {
    category: "security",
    title: "elevators not functional",
    image: EscalatorMaintenance,
    video: EscalatorMaintenanceVideo,
  },
  {
    category: "security",
    title: "re-entry gate closed",
    image: ReEntryGateClosed,
    video: ReEntryGateClosedVideo,
  },
  {
    category: "security",
    title: "camera not functional",
    image: CameraNotFunctional,
    video: CameraNotFunctionalVideo,
  },
  {
    category: "security",
    title: "fire alert",
    image: FireAlert,
    video: FireAlertVideo,
  },
  {
    category: "operations",
    title: "smoke detected",
    image: SmockDeteded,
    video: SmokeDetectedVideo,
  },

  {
    category: "parking",
    title: "parking slot is available",
    image: ParkingAvailable,
    video: ParkingAvailableVideo,
  },
  {
    category: "outdoorambience",
    title: "moderate aqi",
    image: ModerateAQIImage,
    video: ModerateAQIVideo,
  },
  {
    category: "outdoorambience",
    title: "good signal strength",
    image: GoodSignalStrengthImage,
    video: GoodSignalStrengthVideo,
  },
  {
    category: "outdoorambience",
    title: "hazardous aqi",
    image: HazardousAQIImage,
    video: HazardousAQIVideo,
  },
  {
    category: "outdoorambience",
    title: "low bandwidth",
    image: WeakSignalStrengthImage,
    video: WeakSignalStrengthVideo,
  },
  {
    category: "outdoorambience",
    title: "weak signal strength",
    image: WeakSignalStrengthImage,
    video: WeakSignalStrengthVideo,
  },
  {
    category: "outdoorambience",
    title: "high electricity consumption",
    image: HighElectricityConsumptionImage,
    video: HighElectricityConsumptionVideo,
  },
  {
    category: "outdoorambience",
    title: "not operational",
    image: WifiNotOperationalImage,
    video: WifiNotOperationalVideo,
  },
  {
    category: "foodconcessions",
    title: "restaurant is under maintenance",
    image: RestaurantUnderMaintenance,
    video: RestaurantUnderMaintenanceVideo,
  },
  {
    category: "foodconcessions",
    title: "restaurant is under maintenance",
    image: RestaurantUnderMaintenance,
    video: RestaurantUnderMaintenanceVideo,
  },
  {
    category: "foodconcessions",
    title: "restroom cleaning inprogress",
    image: CleaningInprogressImg,
    video: CleaningInprogressVideo,
  },
  {
    category: "foodconcessions",
    title: "entrance gate opened",
    image: GateOpenImg,
    video: GateOpenVideo,
  },
  {
    category: "foodconcessions",
    title: "restaurant is operational now",
    image: RestaurantOperational,
    video: RestaurantOperationalVideo,
  },
  {
    category: "foodconcessions",
    title: "low inventory level",
    image: LowInventoryLevelImage,
    video: LowInventoryLevelVideo,
  },
  {
    category: "foodconcessions",
    title: "order delayed",
    image: OrderDelayedImage,
    video: OrderDelayedVideo,
  },
  {
    category: "foodconcessions",
    title: "pending order",
    image: PendingOrderImage,
    video: PendingOrderVideo,
  },
  {
    category: "foodconcessions",
    title: "crowd forming",
    image: CrowedForming,
    video: CrowedFormingVideo,
  },
  {
    category: "foodconcessions",
    title: "unauthorized access",
    image: UnauthorizedAccess,
    video: UnauthorizedAccessVideo,
  },
  {
    category: "foodconcessions",
    title: "restaurant open",
    image: FoodRestaurantOpenImage,
    video: FoodRestaurantOpenVideo,
  },
  {
    category: "foodconcessions",
    title: "crowd forming",
    image: CrowedForming,
    video: CrowedFormingVideo,
  },
  {
    category: "foodconcessions",
    title: "operational now",
    image: RestaurantOperational,
    video: RestaurantOperationalVideo,
  },
  {
    category: "foodconcessions",
    title: "not operational",
    image: NotOperational,
    video: NotOperationalVideo,
  },
  {
    category: "foodconcessions",
    title: "smoke detected",
    image: SmockDeteded,
    video: SmokeDetectedVideo,
  },

  {
    category: "foodconcessions",
    title: "camera not functional",
    image: CameraNotFunctional,
    video: CameraNotFunctionalVideo,
  },
];

export default List;
